export enum MONEY_CASH_FIELDS {
	FIRST_NAME = 'firstName',
	LAST_NAME = 'lastName',
	MOBILE = 'mobile',
	EMAIL = 'email',
}

export enum MONEY_CASH_FIELDS_IDS {
	FIRST_NAME = 'refunds.moneyCash.form.firstName',
	LAST_NAME = 'refunds.moneyCash.form.lastName',
	MOBILE = 'refunds.moneyCash.form.mobile',
	EMAIL = 'refunds.moneyCash.form.email',
}

export enum MONEY_CASH_FIELDS_LABELS {
	FIRST_NAME = 'form.refunds.cash.name.label',
	LAST_NAME = 'form.refunds.cash.lastName.label',
	MOBILE = 'form.refunds.cash.mobile.label',
}

export enum MONEY_CASH_FIELDS_ERRORS {
	FIRST_NAME = 'form.refunds.cash.checkName.errormessage',
	LAST_NAME = 'form.refunds.cash.checkLastName.errormessage',
	MOBILE = 'form.refunds.cash.checkMobile.errormessage',
}

export enum MONEY_CASH_FIELDS_VALIDATION {
	MAX_LENGTH = 40,
}
